import React from 'react'
import PropTypes from 'prop-types'
import DropdownSelect from '../DropdownSelect'

function UserMultiSelectionInput({azubis, selectedValue, onSelectValue, selectAllText}) {
  const azubiOptions = azubis.map(user => ({value: [user.id], label: `${user.lastname}, ${user.firstname}`}))
  const selectAllOption = {value: azubis.map(a => a.id), label: selectAllText}
  const options = [selectAllOption, ...azubiOptions]

  const selectedOption = options.find(o => o.value === selectedValue)
  return (
    <div className="azubiSelect">
      <DropdownSelect
        options={options}
        selectedOption={selectedOption}
        handleSelect={evt => onSelectValue(evt.value)}
      />
    </div>
  )
}

UserMultiSelectionInput.propTypes = {
  azubis: PropTypes.array,
  selectedValue: PropTypes.arrayOf(PropTypes.number),
  onSelectValue: PropTypes.func,
  selectAllText: PropTypes.string,
}

export default UserMultiSelectionInput
